"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_popover_1 = require("@radix-ui/react-popover");
const react_1 = require("react");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const ClickableIcon_1 = require("../ClickableIcon");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const VerticalRule = (0, styled_1.default)(Div_1.Div)(() => ({
    display: 'block',
    backgroundColor: constants_1.Color.GREY,
    height: constants_1.theme.spacing[3.5],
    width: 1,
}));
const Root = (0, styled_1.default)(Flex_1.Flex)({
    gridArea: 'Actions',
    alignItems: 'baseline',
    gap: constants_1.theme.spacing[1.5],
    paddingTop: constants_1.theme.spacing[3],
    paddingRight: constants_1.theme.spacing[3],
    paddingBottom: constants_1.theme.spacing[3],
});
const Actions = ({ icons, as, onClose, }) => {
    const t = (0, translate_1.useTranslations)();
    const visibleIcons = (0, react_1.useMemo)(() => icons?.filter((icon) => !icon.hidden) ?? utils_1.EMPTY_FROZEN_ARRAY, [icons]);
    if (!visibleIcons.length && !onClose && as !== 'popover') {
        return null;
    }
    const closeClickableIcon = ((0, jsx_runtime_1.jsx)(ClickableIcon_1.ClickableIcon, { onClick: onClose, tooltipText: t.common.close(), iconProps: {
            color: constants_1.Color.DARKEST_MEDIUM_GREY,
            size: 'md',
            name: 'XIcon',
        } }));
    const close = as === 'popover' ? ((0, jsx_runtime_1.jsx)(react_popover_1.Close, { asChild: true, children: closeClickableIcon })) : onClose ? (closeClickableIcon) : null;
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [visibleIcons.map(({ name, onClick, tooltipText, disabled }, index) => ((0, jsx_runtime_1.jsx)(ClickableIcon_1.ClickableIcon, { onClick: onClick, iconProps: {
                    color: constants_1.Color.DARKEST_MEDIUM_GREY,
                    size: 'md',
                    name,
                }, tooltipText: tooltipText, disabled: disabled }, index))), !!visibleIcons.length && close && (0, jsx_runtime_1.jsx)(VerticalRule, {}), close] }));
};
exports.Actions = Actions;
